import { useState } from 'react';

import { FORM_VALIDATION_ERROR } from 'src/app/shared/constants/errorMessages';
import getTrackingAdapter from 'src/app/v1/dataAnalytics';

export const useErrorType = () => {
  const [errorType, setErrorType] = useState('');

  const sendErrorEvent = (errorMessage: string) => {
    const eventData = {
      eventName: FORM_VALIDATION_ERROR,
      errorMessage,
    };
    getTrackingAdapter.sendLinkEvent(eventData);
  };

  const setError = (error: Error | string) => {
    if (error instanceof Error && typeof error.message === 'string') {
      setErrorType(error.message);
      sendErrorEvent(error.message);
    } else if (typeof error === 'string') {
      setErrorType(error);
      sendErrorEvent(error);
    }
  };

  const resetError = () => {
    setErrorType('');
  };

  return {
    errorType,
    setError,
    resetError,
  };
};
